import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58618618"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "UpdatePrice" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "bg-white px-4 py-4 border border-gray-200 flex items-center select-none justify-center text-sm mt-6"
}
const _hoisted_5 = {
  key: 0,
  class: "flex flex-col items-center justify-center"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400" }, "Загрузка данных...", -1))
const _hoisted_7 = {
  key: 1,
  class: "flex flex-col items-center justify-center"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-red-500" }, "При получении данных произошла ошибка", -1))
const _hoisted_9 = {
  key: 1,
  class: "mt-6"
}
const _hoisted_10 = { class: "bg-white px-4 py-4 border border-gray-200" }
const _hoisted_11 = { class: "grid grid-cols-3 gap-3" }
const _hoisted_12 = {
  key: 0,
  class: "bg-white px-4 py-4 border border-gray-200 flex items-center select-none justify-center text-sm mt-6"
}
const _hoisted_13 = {
  key: 0,
  class: "flex flex-col items-center justify-center"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400" }, "Загрузка данных о доп. услугах...", -1))
const _hoisted_15 = {
  key: 1,
  class: "flex flex-col items-center justify-center"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-red-500" }, "При получении данных о доп. услугах произошла ошибка", -1))
const _hoisted_17 = {
  key: 1,
  class: "bg-white px-4 py-4 border border-gray-200 mt-6"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xl font-semibold" }, "Дополнительные услуги", -1))
const _hoisted_19 = { class: "grid grid-cols-3 gap-3 mt-6" }
const _hoisted_20 = { class: "flex items-center justify-end mt-3" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_loader = _resolveComponent("loader")!
  const _component_the_input = _resolveComponent("the-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: _ctx.getTitle }, null, 8, ["title"]),
      _createVNode(_component_the_button, {
        class: "second small text",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Назад ")
        ]),
        _: 1
      })
    ]),
    (_ctx.state.is_loading || _ctx.state.is_failed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.state.is_loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_loader, { class: "primary" }),
                _hoisted_6
              ]))
            : (_ctx.state.is_failed)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(_component_the_button, {
                    class: "small primary mt-1",
                    onClick: _ctx.loadCalculation
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Обновить ")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]))
              : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_the_input, {
                placeholder: "Цена за доставку",
                value: _ctx.form_state.deliveryCharge,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form_state.deliveryCharge) = $event)),
                "is-invalid": _ctx.form_state$.deliveryCharge.$error,
                "validation-errors": _ctx.form_state$.deliveryCharge.$errors,
                disabled: _ctx.state.is_submitting
              }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"]),
              _createVNode(_component_the_input, {
                placeholder: "Цена за страховку",
                value: _ctx.form_state.insuranceCharge,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form_state.insuranceCharge) = $event)),
                "is-invalid": _ctx.form_state$.insuranceCharge.$error,
                "validation-errors": _ctx.form_state$.insuranceCharge.$errors,
                disabled: _ctx.state.is_submitting
              }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"]),
              _createVNode(_component_the_input, {
                placeholder: "Цена за заказ",
                value: _ctx.form_state.orderCharge,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form_state.orderCharge) = $event)),
                "is-invalid": _ctx.form_state$.orderCharge.$error,
                "validation-errors": _ctx.form_state$.orderCharge.$errors,
                disabled: _ctx.state.is_submitting
              }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"]),
              _createVNode(_component_the_input, {
                placeholder: "Цена за упаковку",
                value: _ctx.form_state.packageCharge,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form_state.packageCharge) = $event)),
                "is-invalid": _ctx.form_state$.packageCharge.$error,
                "validation-errors": _ctx.form_state$.packageCharge.$errors,
                disabled: _ctx.state.is_submitting
              }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"]),
              _createVNode(_component_the_input, {
                placeholder: "Цена за выгрузку",
                value: _ctx.form_state.unloadCharge,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form_state.unloadCharge) = $event)),
                "is-invalid": _ctx.form_state$.unloadCharge.$error,
                "validation-errors": _ctx.form_state$.unloadCharge.$errors,
                disabled: _ctx.state.is_submitting
              }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"])
            ])
          ]),
          (_ctx.additional_services_state.is_loading || _ctx.additional_services_state.is_failed)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                (_ctx.additional_services_state.is_loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createVNode(_component_loader, { class: "primary" }),
                      _hoisted_14
                    ]))
                  : (_ctx.additional_services_state.is_failed)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _hoisted_16,
                        _createVNode(_component_the_button, {
                          class: "small primary mt-1",
                          onClick: _ctx.loadAdditionalServices
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Обновить ")
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]))
                    : _createCommentVNode("", true)
              ]))
            : (_ctx.additional_services_state.list.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("div", _hoisted_19, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.additional_services_state.list, (service) => {
                      return (_openBlock(), _createBlock(_component_the_input, {
                        key: service.id,
                        placeholder: _ctx.getAdditionalServiceName(service),
                        disabled: _ctx.state.is_submitting,
                        value: service.cost,
                        "onUpdate:value": ($event: any) => ((service.cost) = $event)
                      }, null, 8, ["placeholder", "disabled", "value", "onUpdate:value"]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_the_button, {
              class: "small primary",
              disabled: _ctx.state.is_submitting,
              loading: _ctx.state.is_submitting,
              onClick: _ctx.onSubmit
            }, {
              default: _withCtx(() => [
                _hoisted_21,
                _createTextVNode(" Сохранить ")
              ]),
              _: 1
            }, 8, ["disabled", "loading", "onClick"])
          ])
        ]))
  ]))
}